import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Section = ({ title, children, className }) => (
  <section className={classNames('section', className)}>
    <h2 className="title-2 is-icon is-solid">{title}</h2>
    {children}
  </section>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Section.defaultProps = {
  className: '',
};

export default Section;
